import React from 'react';

const AppImage = ({ src, alt, fill, className, ...props }) => {
  const styles = fill ? {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  } : {};

  return (
    <img 
      src={src} 
      alt={alt} 
      className={className}
      style={{ ...styles, ...props.style }}
      {...props}
    />
  );
};

export default AppImage;
